import * as React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import ConfirmPrompt from '../ConfirmationPrompt';
import './styles.scss';
import SelectedSponsor from './selectedSponsor';
import Sponsor from './sponsor'
import {
    bulkValidationAcceptReassignActivityRequest as validateBulkAcceptReassignActivity,
    bulkAcceptReassignActivityRequest as changeAcceptReassignActivity,
    getAcceptReassignDataRequest as getAcceptReassignActivtiy,
    resetAcceptReassignActivity
} from '../../containers/ActivityListing/slice';

import {
    clearErrorValidationMessage,
} from '../../containers/SpockViewPage/actions/action';

import { hideDialogueBox } from '../DialogueBox/actions';

let defaultJSON = require("../../i18n/default.json");

import AppLoader from "../AppLoader";
import { FormattedMessage } from 'react-intl';
import UserImage from '../UserImage/index';

class AcceptReassignActivities extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            selectedSponsor: null,
            confirmMessage: null,
            isNotificationSelected: true,
            errorMsg: '',
            isValidWorkkardId: true,
            sponsors: [],
            ownerSearchInput: ''
        };

        this.afterDrophandle = this.afterDrophandle.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.onClearOwnerSearchInput = this.onClearOwnerSearchInput.bind(this);
    }

    componentWillReceiveProps(newProp) {
        if (!!newProp.errorValidationMessage.errorMessage) {
            this.setState({
                errorMsg: newProp.errorValidationMessage.errorMessage
            })
            return;
        }
        if (newProp.acceptReassignActivity && newProp.acceptReassignActivity.assigneeList && this.state.sponsors !== newProp.acceptReassignActivity.assigneeList) {
            this.setState({
                sponsors: newProp.acceptReassignActivity.assigneeList,
                currentSponsor: newProp.acceptReassignActivity.orgList
            })
        }

        if (newProp.acceptReassignActivity.totalActivitysCount || newProp.acceptReassignActivity.validActivitysCount) {
            if (!newProp.acceptReassignActivity.validActivitysCount) {
                this.setState({
                    errorMsg: `This action is not valid on the selected records.`
                })
            }
            if (newProp.acceptReassignActivity.totalActivitysCount > newProp.acceptReassignActivity.validActivitysCount) {
                this.setState({
                    confirmMessage: `This action is available on ${newProp.acceptReassignActivity.validActivitysCount} out of ${newProp.acceptReassignActivity.totalActivitysCount} Workkards selected. Do you want to continue?`
                })
            }
            if (newProp.acceptReassignActivity.totalActivitysCount > 0 && (newProp.acceptReassignActivity.totalActivitysCount == newProp.acceptReassignActivity.validActivitysCount)) {
                this.setState({
                    confirmMessage: `Are you sure you want to accept & reassign activity(s)?`
                })
            }
        }
    }

    componentDidMount() {
        let validActIds = [];
        if (this.props.isMulti) {
            validActIds = this.props.activityIds
        }
        if ((this.props.isMulti !== undefined && !this.props.isMulti && !this.props.activityIds.length) || (this.props.isMulti && !validActIds.length)) {
            this.setState({
                errorMsg: 'This action is not valid on the selected records.',
                isValidActivityId: false
            })
            return;
        }
        this.props.getAcceptReassignActivtiy({ _: + new Date() });
    }

    componentWillUnmount() {
        this.props.resetAcceptReassignActivity();
    }

    onCancelClick() {
        this.setState({
            selectedSponsor: null
        });
    };

    onConfirmClick() {
        const selectedSponsor = this.state.selectedSponsor

        const finalReqPayload = {
            'ids': JSON.stringify(this.props.acceptReassignActivity.validActivtyId),
            'pnum': 1,
            'aid': selectedSponsor.UserId,
        };

        this.props.changeAcceptReassignActivity(finalReqPayload);
        this.props.clearErrorValidationMessage();
        this.props.hideDialogueBox();
    }

    onTextChange(event) {
        const searchQuery = event.target.value.toLowerCase();
        this.setState({
            ownerSearchInput: searchQuery
        });

        const filteredArr = this.props.acceptReassignActivity.assigneeList.filter((model) => {
            return model.FirstName.toLowerCase().search(searchQuery.trim()) !== -1 ||
                model.LastName.toLowerCase().search(searchQuery.trim()) !== -1 ||
                model.Email.toLowerCase().search(searchQuery.trim()) !== -1 ||
                model.JobTitle.toLowerCase().search(searchQuery.trim()) !== -1 ||
                (model.FirstName + " " + model.LastName).toLowerCase().search(searchQuery.trim()) !== -1;
        });

        this.setState({
            sponsors: filteredArr
        });
    }

    onClearOwnerSearchInput() {
        if (this.props.acceptReassignActivity.assigneeList) {
            this.setState({
                sponsors: this.props.acceptReassignActivity.assigneeList,
                ownerSearchInput: ''
            })
        }
    }

    afterDrophandle(data) {
        this.setState({
            selectedSponsor: data,
            ownerSearchInput: ''
        });
        this.props.validateBulkAcceptReassignActivity({ ids: JSON.stringify(this.props.activityIds), type: 'AcceptAndReassignActivity' });
    }

    closeDialogueBox = () => {
        this.props.clearErrorValidationMessage();
        this.props.hideDialogueBox();
    }

    render() {
          if(this.props.isLoading){
            return <AppLoader isLoading={true } />
        }
        if ((this.state.sponsors.length === 0 || !this.state.isValidWorkkardId) && this.state.errorMsg) {
            return (
                <div>
                    {this.state.errorMsg}
                    <div>
                        <div className="control-bar">
                            <button className="confirm element center" onClick={this.closeDialogueBox }>
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="change-owner-container popup-min-height">
                    {
                        (this.state.sponsors.length === 0 && this.state.errorMsg === '' && this.state.ownerSearchInput === '')
                            ?
                            (
                                // <Loader msg={"Loading workkard owner list.."} />
                                <AppLoader isLoading={ true } />
                            )
                            :
                            (
                                <div className="user_content">
                                    <div className="PopupHeader">
                                        <div className="lt_hlp_txt">
                                            <FormattedMessage id="assignee.drag_drop" defaultMessage={defaultJSON['assignee.drag_drop']}/>
                                        </div>
                                        {
                                            (this.state.selectedSponsor === null)
                                            ?
                                            (
                                            <div className="rt_search_ctr">
                                                <input className="search_inpt" value={this.state.ownerSearchInput} onChange={this.onTextChange} type="text" placeholder="Search by Name, Job Title or Email" max="30" />
                                                {
                                                    (this.state.ownerSearchInput !== '')
                                                    ?
                                                    (
                                                        <a style={{ display: "block" }} href="javascript:void(0);" className="clear_search" onClick={this.onClearOwnerSearchInput}></a>
                                                    )
                                                    :
                                                    null

                                                }

                                            </div>

                                            )
                                            :
                                            (null)
                                        }

                                    </div>
                                    <div className="clr"></div>

                                    <div style={{ 'position': 'relative', 'overflowY': 'scroll', 'overflowX': 'hidden', 'height': '400px', 'marginTop': '-20px', 'width': '100%' }}>
                                        <div className="refPopupLeft">
                                            <div className="drag_img_left">
                                                <div className="drag_img marauto">
                                                    <div className="dragger_box ui-draggable" style={{ position: 'relative' }}>
                                                        <UserImage profileUrl={this.state.currentSponsor.ProfileFullImage} profileName={this.state.currentSponsor.OrganizationName}/>
                                                        <a href="javascript:void(0);" title={this.state.currentSponsor.OrganizationName}>{this.state.currentSponsor.OrganizationName}</a>
                                                        {/* <span className="role" title={this.state.currentSponsor.JobTitle}>{this.state.currentSponsor.JobTitle}</span>
                                                        <span className="email" title={this.state.currentSponsor.Email}>{this.state.currentSponsor.Email}</span> */}
                                                    </div>
                                                </div>
                                                <div className="drag_arrow">
                                                    <span className="arrow_down_drag"></span>
                                                </div>
                                                <div style={{ display: 'block' }}>
                                                    <SelectedSponsor data={(this.state.selectedSponsor ? this.state.selectedSponsor : null)} />
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            (this.state.errorMsg)
                                                ?
                                                (
                                                    <div className="drag_img_right bulkActionDrag">
                                                        <div className="match_confirm_info tac">
                                                            <div className="match_error_info">
                                                                <div className="marb10">
                                                                    <span> {this.state.errorMsg}</span>
                                                                </div>
                                                                <div className="control-bar">
                                                                    <button className="confirm element center" onClick={ this.closeDialogueBox }>
                                                                        OK
                                                                    </button>
                                                                </div>
                                                                <div className="clr"></div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                )
                                                :
                                                (
                                                    <div className="drag_img_right bulkActionDrag bulkActionPopup">
                                                        {
                                                            (this.state.sponsors && this.state.sponsors.length > 0 && !this.state.selectedSponsor)
                                                                ?
                                                                (
                                                                    <div className="user_reassign_area">
                                                                        {
                                                                            this.state.sponsors.map((row, index) => (
                                                                                <Sponsor key={row.UserId} onDrop={this.afterDrophandle} data={row} />
                                                                            ))
                                                                        }
                                                                        <div className="clr">&nbsp;</div>
                                                                    </div>
                                                                )
                                                                :
                                                                null
                                                        }

                                                        {
                                                            (!this.state.selectedSponsor && this.state.sponsors.length == 0)
                                                                ?
                                                                (
                                                                    <div className="error_m"><span className="ex_ico"></span><FormattedMessage id="no_user_available" defaultMessage={defaultJSON['no_user_available']}/></div>                                                                )
                                                                :
                                                                null
                                                        }


                                                        {
                                                            (this.state.selectedSponsor)
                                                                ?
                                                                (
                                                                    <div className="alignCenter colFlex">
                                                                        <ConfirmPrompt
                                                                            className={'match_confirm_info tac'}
                                                                            message={this.state.confirmMessage}
                                                                            onCancelClick={this.onCancelClick}
                                                                            onConfirmClick={this.onConfirmClick}
                                                                            bothButton={true}
                                                                            middleText={''}
                                                                        />
                                                                    </div>
                                                                )
                                                                :
                                                                null
                                                        }
                                                        <div className="clr"></div>
                                                    </div>
                                                )
                                        }
                                    </div>
                                </div>
                            )
                    }
                </div>
            );
        }
       
    }
}

const mapStateToProps = (state) => ({
    acceptReassignActivity: state.activityListing.bulkAction,
    errorValidationMessage: state.validationError,
    isLoading: state.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
    validateBulkAcceptReassignActivity: bindActionCreators(validateBulkAcceptReassignActivity, dispatch),
    changeAcceptReassignActivity: bindActionCreators(changeAcceptReassignActivity, dispatch),
    getAcceptReassignActivtiy: bindActionCreators(getAcceptReassignActivtiy, dispatch),
    clearErrorValidationMessage: bindActionCreators(clearErrorValidationMessage, dispatch),
    hideDialogueBox: bindActionCreators(hideDialogueBox, dispatch),
    resetAcceptReassignActivity: bindActionCreators(resetAcceptReassignActivity, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AcceptReassignActivities);